import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, TrendingUp, Shield, Globe } from 'lucide-react';
import { Button } from '../components/ui/button';
import { mockData } from '../mock';

const Home = ({ currentLang }) => {
  const t = mockData.translations[currentLang];

  return (
    <div className="bg-black min-h-screen">
      {/* Hero Section */}
      <section className="pt-24 pb-20">
        <div className="px-[7.6923%]">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-8">
              <div>
                <h1 className="text-6xl font-bold text-white leading-tight mb-6">
                  {t.hero.title}
                </h1>
                <p className="text-xl text-white/85 leading-relaxed mb-8">
                  {t.hero.subtitle}
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Button 
                  asChild
                  className="btn-primary bg-[#00FFD1] text-black hover:bg-[#00FFD1]/90 border-none rounded-none py-4 px-8 text-lg font-medium min-h-[56px] transition-all duration-400"
                >
                  <Link to="/investor" className="flex items-center gap-3">
                    {t.buttons.explore}
                    <ArrowRight className="h-5 w-5" />
                  </Link>
                </Button>
                
                <Button 
                  asChild
                  variant="outline"
                  className="btn-secondary bg-white/10 text-white border-none rounded-none py-4 px-8 text-lg font-medium min-h-[56px] hover:bg-white hover:text-black transition-all duration-400"
                >
                  <Link to="/about">
                    {t.buttons.learnMore}
                  </Link>
                </Button>
              </div>
            </div>

            {/* Right Content - 3D Animation */}
            <div className="flex justify-center">
              <div className="w-[700px] h-[700px] bg-gradient-to-br from-[#00FFD1]/20 to-transparent rounded-lg flex items-center justify-center border border-[#00FFD1]/30">
                <div className="text-center">
                  <div className="w-32 h-32 mx-auto mb-4 bg-[#00FFD1]/30 rounded-full flex items-center justify-center animate-pulse">
                    <TrendingUp className="w-16 h-16 text-[#00FFD1]" />
                  </div>
                  <p className="text-white/60">AI & Blockchain</p>
                  <p className="text-white/40 text-sm">Investment Focus</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 border-t border-white/25">
        <div className="px-[7.6923%]">
          <div className="grid md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-[#00FFD1]/20 rounded-lg flex items-center justify-center">
                <TrendingUp className="w-8 h-8 text-[#00FFD1]" />
              </div>
              <h3 className="text-3xl font-bold text-white mb-2">$85-105M</h3>
              <p className="text-white/70">Target Investment Range</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-[#00FFD1]/20 rounded-lg flex items-center justify-center">
                <Shield className="w-8 h-8 text-[#00FFD1]" />
              </div>
              <h3 className="text-3xl font-bold text-white mb-2">15+</h3>
              <p className="text-white/70">Years Experience</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-[#00FFD1]/20 rounded-lg flex items-center justify-center">
                <Globe className="w-8 h-8 text-[#00FFD1]" />
              </div>
              <h3 className="text-3xl font-bold text-white mb-2">SEA</h3>
              <p className="text-white/70">Southeast Asia Focus</p>
            </div>
          </div>
        </div>
      </section>

      {/* Focus Areas Preview */}
      <section className="py-20 border-t border-white/25">
        <div className="px-[7.6923%]">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">Investment Focus Areas</h2>
            <p className="text-xl text-white/70 max-w-2xl mx-auto">
              Specialized investments in cutting-edge technologies that shape the future
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {mockData.services.slice(0, 4).map((service, index) => (
              <div key={index} className="bg-white/5 border border-white/20 p-6 hover:bg-white/10 transition-all duration-300">
                <div className="w-12 h-12 mb-4 bg-[#00FFD1]/20 rounded-lg flex items-center justify-center">
                  <div className="w-6 h-6 bg-[#00FFD1] rounded-sm"></div>
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">{service.title}</h3>
                <p className="text-white/70 text-sm leading-relaxed">
                  {service.description.substring(0, 120)}...
                </p>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <Button 
              asChild
              className="btn-primary bg-[#00FFD1] text-black hover:bg-[#00FFD1]/90 border-none rounded-none py-4 px-8 text-lg font-medium min-h-[56px]"
            >
              <Link to="/services">
                View All Services
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;